// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1wqRh","requiredAsterisk":"Info_requiredAsterisk__11UrD"};